import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { HttpClient } from "@angular/common/http";
import { CookieNames, JeanologiaNgSsoauthService } from "@jeanologia/ng-ssoauth";
import { map } from "rxjs/operators";
import { firstValueFrom, Observable } from "rxjs";
import { jwtDecode } from "jwt-decode";

import { Service } from "../service.class";

@Injectable()
export class AuthenticationService {
	constructor(private http: HttpClient, private router: Router, private service: Service, private ssoauth_service: JeanologiaNgSsoauthService) {}
	/**
	 * Array de visibilidades del usuario
	 */
	private visibilities: string[] = [];

	public _get(url: string, id: string): Observable<any> {
		return this.service.getSingle(url, id);
	}

	public _put(url: string, data: object, id: string): Observable<any> {
		return this.service.apiPutId(url, data, id);
	}

	public getDecodedAccessToken(token: string): any {
		try {
			return jwtDecode(token);
		} catch (Error) {
			return null;
		}
	}

	// Clear token remove user from local storage to log user out
	public logOut(): void {
		//this.ssoauth_service.logout();
	}

	public checkAdminPermissions(roleToCheck?: string, routeToNavigate?: string): void {
		const userScope: string | Array<string> = this.ssoauth_service.get("scope");
		if (userScope && Array.isArray(userScope) && userScope.indexOf(roleToCheck) === -1) {
			this.router.navigate([routeToNavigate]);
		}
	}

	public checkUsersPermissions(roleToCheck?: string, routeToNavigate?: string): boolean {
		const userScope: string | Array<string> = this.ssoauth_service.get("scope");
		if (userScope && Array.isArray(userScope) && userScope.indexOf(roleToCheck) !== -1) {
			this.router.navigate([routeToNavigate]);
			return false;
		}
		return true;
	}

	public isUserRoleAllowed(rolesToCheck: string[]): boolean {
		const userScope: any = this.getJeanologiaScope();
		return rolesToCheck.indexOf(userScope) !== -1;
	}

	public getJeanologiaScope(): string | null {
		const scope = this.ssoauth_service.getCookie(CookieNames.JEANAPI).token.scope;

		if (Array.isArray(scope) && scope.length === 2) {
			const isSat = scope.find((ele) => ele === "sat");
			if (isSat) return isSat;
		}
		if (Array.isArray(scope) && scope.length > 0) {
			return scope[0];
		}
		return null;
	}

	public async getCookie(): Promise<any> {
		return await this.ssoauth_service.getCookies();
	}

	public isAdminUser(): boolean {
		const scopes: string[] = this.getRolScopes();
		return scopes.includes("marketplace-admin");
	}

	public isBuyerUser(): boolean {
		const scopes: string[] = this.getRolScopes();
		return scopes.includes("marketplace-buyer");
	}

	public isSat(): boolean {
		const scopes: string[] = this.getRolScopes();
		return scopes.includes("marketplace-sat");
	}

	public async getVisibilities(): Promise<string[]> {
		const user_id = localStorage.getItem("user");
		const result : string[] = await firstValueFrom(
			this.ssoauth_service.getUserVisibilities({ customer : user_id}).pipe(
				map((v: any) => {
					this.visibilities = v;
					return v;
				}),
			),
		);
		return result;
	}

	public getVisibilitiesCache(): string[] {
		return this.visibilities;
	}

	public async isUserAllowed(visibility: string): Promise<boolean> {
		if (this.visibilities.length === 0) {
			await this.getVisibilities();
			return this.visibilities.includes(visibility);
		} else {
			return this.visibilities.includes(visibility);
		}
	}

	public getRolScopes(): string[] {
		const scope = this.ssoauth_service.getCookie(CookieNames.JEANAPI).token.scope;
		return scope;
	}
}
